<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{
                $t('SeaExport.CodeSearching')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{
                $t('SeaExport.CopyFromTheLastTime')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{
                $t('SeaExport.CopyFromOtherBill')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromHbl')">{{
                $t('SeaExport.CopyFromHbl')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="2"
            :disabled="feedBtnDisabled"
            type="primary"
            @click="pm.completefeedClickHandler()"
          >{{ $t('SeaExport.CompleteTheDetails') }}
          </el-button>
          <el-dropdown
            no="3"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{
                $t('SeaExport.InviteToChecktheBL')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-permission="['button_M/HBL_confirmBL']"
                :command="$t('SeaExport.ConfirmChecking')"
              >{{ $t('SeaExport.ConfirmChecking') }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_M/HBL_identification'])"
                :command="$t('SeaExport.IdentificationList')"
              >{{ $t('SeaExport.IdentificationList') }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{
                $t('SeaExport.CheckingHistory')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ReceiptHistory')">{{
                $t('SeaExport.ReceiptHistory')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.BillingOfLadingRecordManager')">{{
                $t('SeaExport.BillingOfLadingRecordManager')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="viewSource === 'SeBooking'"
            v-permission="['button_insurance_toInsure']"
            no="4"
            :disabled="isEdit"
            type="primary"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}
          </el-button>
          <el-menu
            :disabled="!(action === 'look' && form.uuid)"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="width: 80px;vertical-align: top"
            @select="toBlPre"
          >
            <el-submenu index="index" :disabled="!(action === 'look' && form.uuid)">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIDoc') }}</span>
              <el-submenu index="original">
                <template slot="title">{{ $t('SeaExport.Original') }}</template>
                <el-menu-item index="API0" :disabled="!billEDIApiOpen">API</el-menu-item>
                <el-menu-item index="FTP1">FTP</el-menu-item>
              </el-submenu>
              <el-submenu index="correct">
                <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                <el-menu-item index="FTP0">FTP</el-menu-item>
                <el-menu-item index="API1" :disabled="!billEDIApiOpen">API</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
          <el-button
            v-if="!job.masterFlag || (job.containerLoadType === LCL_CARGO_TYPE.code)"
            no="EdiEuBolInfo"
            :disabled="!(action === 'look' && form.uuid)"
            type="primary"
            @click="ediEuBolInfoHandler"
          >{{ $t('SeaExport.EdiEuBolInfo') }}</el-button>
          <el-button
            v-show="btnMergeHblDataVisible"
            no="5"
            :disabled="readonly"
            type="primary"
            @click="pm.mergeHblData()"
          >{{ $t('SeaExport.mergeHblData') }}
          </el-button>
          <el-checkbox
            no="6"
            :value="form.state>=2"
            :disabled="true"
            style="margin-left: 10px"
          >{{ $t('SeaExport.Printed') }}
          </el-checkbox>
          <el-checkbox
            no="7"
            style="margin-left: -20px;"
            :value="form.state===3"
            :disabled="true"
          >{{ $t('SeaExport.Locked') }}
          </el-checkbox>
          <el-checkbox
            v-show="enableShipperConsignNotify"
            v-model="job.shipperLock"
            no="shipperLock"
            style="margin-left: -20px;"
            :disabled="true"
          >{{ $t('SeaExport.ShipperLocked') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.oversea"
            no="8"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{ $t('SeaExport.BlBeReleased') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.edi"
            no="9"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{ $t('SeaExport.BlEdi') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.manifestEDI"
            no="10"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{ $t('SeaExport.ManifestEdi') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.printParam1"
            no="11"
            style="margin-left: -20px;"
            :disabled="readonly"
          >Part of
          </el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="12"
            style="margin-left: -20px;"
            :disabled="readonly"
          >{{
            $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS')
          }}
          </el-checkbox>
          <el-checkbox
            v-show="job.barge"
            v-model="form.printParam6"
            no="13"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="pm.printParam6Change()"
          >{{ $t('SeaExport.PrintBargeVesselAndVoyage') }}
          </el-checkbox>
          <el-checkbox
            v-model="form.showPODAgency"
            no="14"
            style="margin-left: -20px;"
            :disabled="readonly"
          >ShowPODAgency
          </el-checkbox>
          <el-button
            v-show="btnExcelVisible"
            no="15"
            style="margin-right: 10px;"
            type="primary"
            @click="pm.exportToExcel()"
          >{{ $t('SeaExport.ExportToExcel') }}
          </el-button>
        </div>
      </div>
    </div>
    <tab-MBLUICustom-layout :element-blocks="elementBlocks">
      <template v-if="!form.showDetail">
        <el-form-item slot="detailFormat" style="display: flex; justify-content: flex-end;margin-top: -24px;">
          <el-button no="formatChange" :disabled="readonly" type="primary" @click="formatChange(true)">{{ $t('CargoMsg.Cargo_DetailFormat') }} </el-button>
        </el-form-item>
        <template v-if="elementDict.shipper.viewable" slot="shipper">
          <el-form-item
            class="auto-width"
            :class="variableCss.shipperCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.shipper.isRequire ? 'blue ' : ' ') + variableCss.shipperLine" :label="elementDict.shipper.label" />
              <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                no="16"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="17"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                style="flex:1"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
              />
              <el-button
                no="18"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                @click="pm.onClear(1)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            class="auto-width"
            :class="getClass('shipperLine',count)"
          >
            <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
              <cargo-input
                :ref="'shipperLine'+count"
                v-model="form['shipperLine'+count]"
                :no="'shipperLine'+count"
                :placeholder="placeholderSFT(count)"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
        </template>
        <template v-if="elementDict.consignee.viewable" slot="consignee">
          <el-form-item
            class="auto-width"
            :class="variableCss.consigneeCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.consignee.isRequire ? 'blue' : '') + variableCss.consigneeLine" :label="elementDict.consignee.label" />
              <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="19"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="20"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
              />
              <el-button
                no="21"
                type="primary"
                :disabled="readonly || !elementDict.consignee.writable"
                style="margin-left: 5px"
                @click="pm.onClear(2)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            class="auto-width"
            :class="getClass('consigneeLine',count)"
          >
            <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
              <cargo-input
                :ref="'consigneeLine'+count"
                v-model="form['consigneeLine'+count]"
                :disabled="readonly || !elementDict.consignee.writable"
                :no="'consigneeLine'+count"
                :placeholder="placeholderSFT(count)"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
        </template>
        <template v-if="elementDict.notify.viewable" slot="notify">
          <el-form-item
            class="auto-width"
            :class="variableCss.notifyCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.notify.isRequire ? 'blue ' : ' ') + variableCss.notifyLine" :label="elementDict.notify.label" />
              <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="22"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="23"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
              />
              <div style="margin-top: 5px">
                <el-button
                  no="24"
                  type="primary"
                  :disabled="readonly || !elementDict.notify.writable"
                  @click="pm.onClear(3)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
                <el-button
                  no="25"
                  type="primary"
                  :disabled="readonly || !elementDict.notify.writable"
                  style="margin-left: 5px"
                  @click="pm.onCopyConsignee()"
                >{{ $t('SeaExport.CopyTheConsignee') }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            class="auto-width"
            :class="getClass('notifyLine',count)"
          >
            <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
              <cargo-input
                :ref="'notifyLine'+count"
                v-model="form['notifyLine'+count]"
                :disabled="readonly || !elementDict.notify.writable"
                :no="'notifyLine'+count"
                :placeholder="placeholderSFT(count)"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
              />
            </special-character-tip>
          </el-form-item>
          <el-form-item>
            <div style="display: flex;">
              <el-select
                v-model="otherSelectField"
                :disabled="readonly || !elementDict.notify.writable"
                no="26"
                style="flex: 1"
                @change="val=>{pm.otherInfoChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in otherFieldsData"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </el-select>
              <cargo-input
                v-if="otherSelectField!=='ALSO NOTIFY'"
                v-model="otherCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="27"
                :maxlength="maxChars"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                style="flex: 1;margin-left: 5px;"
              />
              <cargo-advance-select
                v-if="otherSelectField==='ALSO NOTIFY'"
                :disabled="readonly || !elementDict.notify.writable"
                no="68"
                :allow-create="true"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                tag-name="englishName"
                tag-value="englishName"
                filterable
                style="flex: 1;margin-left: 5px;"
                :default-value="otherCode||''"
                @parentCallBack="p=>{pm.alsoNotifyAutoCompleteChange(p)}"
              />
            </div>
          </el-form-item>
          <el-form-item v-show="otherSelectField==='ALSO NOTIFY'">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              :disabled="readonly || !elementDict.notify.writable"
              no="28"
              :text-chars="0"
              wrap-symbol="r"
              auto-half-word
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},false,null,notUppercaseShipperConsigneNotify, {
                warningCount: 45,
                maxChar: 0,autoUppercase:notUppercaseShipperConsigneNotify,autoHalfWord:true
              })"
            />
          </el-form-item>
          <div v-show="otherSelectField==='DGCONSIGN'">
            <el-form-item
              v-for="count in 7"
              :key="'dgconsignLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'dgconsignLine'+count"
                v-model="form['dgconsignLine'+count]"
                :disabled="readonly || !elementDict.notify.writable"
                no="29"
                :auto-uppercase="isUppercase"
                :use-read-only="true"
                @dblclick.native="showDgconsignDialog"
                @change="()=>wrapAddr(form,'dgconsignLine'+count,count+1 > 6 ? null :'dgconsignLine'+(count+1),maxChars)"
              />
            </el-form-item>
          </div>
          <div v-show="otherSelectField==='ELSEINVOICE'">
            <el-form-item
              v-for="count in 7"
              :key="'elseInvoiceLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'elseInvoiceLine'+count"
                v-model="form['elseInvoiceLine'+count]"
                :disabled="readonly || !elementDict.notify.writable"
                no="30"
                :auto-uppercase="isUppercase"
                :use-read-only="true"
                @dblclick.native="showElseInvoiceDialog"
                @change="()=>wrapAddr(form,'elseInvoiceLine'+count,count+1 > 6 ? null :'elseInvoiceLine'+(count+1),maxChars)"
              />
            </el-form-item>
          </div>
        </template>
        <template v-if="elementDict.payment.viewable" slot="payment">
          <el-form-item
            v-if="job.paymentTermMBL === '3P'"
            class="auto-width"
            style="padding-top: 5px"
          >
            <line-label slot="label" :class="elementDict.payment.isRequire ? 'blue' : ''" :label="elementDict.payment.label" />
            <div style="display: flex;width: 100%">
              <el-input
                v-model="form.paymentCode"
                :disabled="readonly || !elementDict.payment.writable"
                no="paymentCode"
                style="flex:1"
              />
              <el-button
                no="BringInData"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || !elementDict.payment.writable"
                @click="pm.paymentImportData(true)"
              >{{ $t('CargoMsg.Cargo_BringInData') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            v-if="job.paymentTermMBL === '3P'"
            :key="'paymentLine'+count"
            class="auto-width"
          >
            <cargo-input
              :ref="'paymentLine'+count"
              v-model="form['paymentLine'+count]"
              :disabled="readonly || !elementDict.payment.writable"
              :no="'paymentLine'+count"
              :placeholder="placeholderSFT(count)"
              :auto-uppercase="isUppercase"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine'+count,count+1 > 6 ? null :'paymentLine'+(count+1),0)"
            />
          </el-form-item>
        </template>
      </template>
      <template v-if="form.showDetail">
        <el-form-item slot="detailFormat" style="display: flex; justify-content: flex-end;margin-top: -24px;">
          <el-button no="GeneralFormat" :disabled="readonly" type="primary" @click="formatChange(false)">{{ $t('CargoMsg.Cargo_GeneralFormat') }} </el-button>
        </el-form-item>
        <!--  发货人 -->
        <template v-if="elementDict.shipper.viewable" slot="shipper">
          <el-form-item
            class="auto-width"
            :class="variableCss.shipperCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.shipper.isRequire ? 'blue ' : ' ') + variableCss.shipperLine" :label="elementDict.shipper.label" />
              <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="shipperCode"
                v-model="form.shipperCode"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                no="16"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="17"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ shipper: true, active: true }"
                filterable
                :default-value="form.shipperId||''"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                style="flex:1"
                @parentCallBack="p=>{pm.shipperAutoCompleteChange(p, true)}"
              />
              <el-button
                no="18"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || (!readonly && job.shipperLock) || !elementDict.shipper.writable"
                @click="pm.onClear(1, true)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine1"
              :disabled="readonly || !elementDict.shipper.writable"
              no="shipperLine1"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine1','shipperLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine2"
              :disabled="readonly || !elementDict.shipper.writable"
              no="shipperLine2"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine2','shipperLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.shipperLine3"
              :disabled="readonly || !elementDict.shipper.writable"
              no="shipperLine3"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showShipperDialog"
              @change="()=>wrapAddr(form,'shipperLine3','shipperLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            style="margin-bottom: -10px"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperCountry"
                no="shipperCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperCity"
                  no="shipperCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperProvince"
                no="shipperProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperZipCode"
                  no="shipperZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.shipperMobile"
                no="shipperMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.shipperEmail"
                  no="shipperEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.shipper.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.shipperContact"
                no="shipperContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.shipper.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.shipperFax"
                  no="shipperFax"
                  style="width: 100px"
                  :disabled="readonly"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <!-- 收货人 -->
        <template v-if="elementDict.consignee.viewable" slot="consignee">
          <el-form-item
            class="auto-width"
            :class="variableCss.consigneeCode"
          >
            <line-label slot="label" :class="(elementDict.consignee.isRequire ? 'blue ' : ' ') + variableCss.consigneeLine" :label="elementDict.consignee.label" />              <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="consigneeCode"
                v-model="form.consigneeCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="19"
                style="flex:1"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.consignee.writable"
                no="20"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ consignee: true, active: true }"
                filterable
                :default-value="form.consigneeId||''"
                style="flex:1"
                @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p, true)}"
              />
              <el-button
                no="21"
                type="primary"
                :disabled="readonly || !elementDict.consignee.writable"
                style="margin-left: 5px"
                @click="pm.onClear(2, true)"
              >{{ $t('SeaExport.Reset') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine1"
              :disabled="readonly || !elementDict.consignee.writable"
              no="consigneeLine1"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine1','consigneeLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine2"
              :disabled="readonly || !elementDict.consignee.writable"
              no="consigneeLine2"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine2','consigneeLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.consigneeLine3"
              :disabled="readonly || !elementDict.consignee.writable"
              no="consigneeLine3"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showConsigneeDialog"
              @change="()=>wrapAddr(form,'consigneeLine3','consigneeLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeCountry"
                style="width: 100px"
                no="consigneeCountry"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeCity"
                  no="consigneeCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeProvince"
                no="consigneeProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeZipCode"
                  no="consigneeZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.consigneeMobile"
                no="consigneeMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.consigneeEmail"
                  no="consigneeEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.consigneeContact"
                no="consigneeContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.consignee.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.consigneeFax"
                  no="consigneeFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.consignee.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <template v-if="elementDict.notify.viewable" slot="notify">
          <!-- 通知人 -->
          <el-form-item
            class="auto-width"
            :class="variableCss.notifyCode"
          >
            <template slot="label">
              <line-label :class="(elementDict.notify.isRequire ? 'blue ' : ' ') + variableCss.notifyLine" :label="elementDict.notify.label" />
              <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div>
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                ref="notifyCode"
                v-model="form.notifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="22"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="23"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                filterable
                :default-value="form.notifyId||''"
                @parentCallBack="p=>{pm.notifyAutoCompleteChange(p, true)}"
              />
              <div style="margin-top: 5px">
                <el-button
                  no="24"
                  type="primary"
                  :disabled="readonly || !elementDict.notify.writable"
                  @click="pm.onClear(3, true)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
                <el-button
                  no="25"
                  type="primary"
                  :disabled="readonly || !elementDict.notify.writable"
                  style="margin-left: 5px"
                  @click="pm.onCopyConsignee(true)"
                >{{ $t('SeaExport.CopyTheConsignee') }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine1"
              no="notifyLine2"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine1','notifyLine2',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine2"
              no="notifyLine2"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine2','notifyLine3',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.notifyLine3"
              no="notifyLine3"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showNotifyDialog"
              @change="()=>wrapAddr(form,'notifyLine3','notifyLine4',maxChars)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyCountry"
                no="notifyCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyCity"
                  no="notifyCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyProvince"
                no="notifyProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyZipCode"
                  no="notifyZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.notifyMobile"
                no="notifyMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.notifyEmail"
                  no="notifyEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.notifyContact"
                no="notifyContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.notifyFax"
                  no="notifyFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <!-- ALSO NOTIFY -->
          <el-form-item>
            <div style="display: flex;">
              <el-select
                v-model="otherSelectField"
                no="otherSelectField"
                :disabled="readonly || !elementDict.notify.writable"
                style="flex: 1"
                @change="val=>{pm.otherInfoChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in otherFieldsData"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </el-select>
              <cargo-input
                v-if="otherSelectField!=='ALSO NOTIFY'"
                v-model="otherCode"
                :disabled="readonly || !elementDict.notify.writable"
                no="maxChars"
                :maxlength="maxChars"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                style="flex: 1;margin-left: 5px;"
              />
              <cargo-advance-select
                v-if="otherSelectField==='ALSO NOTIFY'"
                :disabled="readonly || !elementDict.notify.writable"
                no="otherCode"
                :allow-create="true"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                tag-name="englishName"
                tag-value="englishName"
                filterable
                style="flex: 1;margin-left: 5px;"
                :default-value="otherCode||''"
                @parentCallBack="p=>{pm.alsoNotifyAutoCompleteChange(p)}"
              />
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line1"
              no="alsoNotifyLine1"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line2"
              no="alsoNotifyLine2"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="alsoNotify.line3"
              no="alsoNotifyLine3"
              :disabled="readonly || !elementDict.notify.writable"
              :filter-chars="false"
              :use-read-only="true"
              :auto-uppercase="true"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                warningCount: 45,
                maxChar: 0,autoUppercase:true,autoHalfWord:true
              })"
              @change="alsoChange"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyCountry"
                no="alsoNotifyCountry"
                style="width: 100px"
                :disabled="readonly"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyCity"
                  no="alsoNotifyCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyProvince"
                no="alsoNotifyProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyZipCode"
                  no="alsoNotifyZipCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.alsoNotifyMobile"
                no="alsoNotifyMobile"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.alsoNotifyEmail"
                  no="alsoNotifyEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.alsoNotifyContact"
                no="alsoNotifyContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.notify.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.alsoNotifyFax"
                  no="alsoNotifyFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.notify.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <!--          付款方-->
        <div v-if="elementDict.payment.viewable && job.paymentTermMBL === '3P'" slot="payment">
          <el-form-item
            class="auto-width"
          >
            <line-label slot="label" :class="elementDict.payment.isRequire ? 'blue' : ''" :label="elementDict.payment.label" />
            <div style="display: flex;width: 100%">
              <el-input
                v-model="form.paymentCode"
                no="paymentCode"
                :disabled="readonly || !elementDict.payment.writable"
                style="flex:1"
              />
              <el-button
                no="BringInData"
                type="primary"
                style="margin-left: 5px"
                :disabled="readonly || !elementDict.payment.writable"
                @click="pm.paymentImportData(false)"
              >{{ $t('CargoMsg.Cargo_BringInData') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Name')"
            class="auto-width"
          >
            <cargo-input
              v-model="form.paymentLine1"
              no="paymentLine1"
              :disabled="readonly || !elementDict.payment.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine1','paymentLine2',0)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '1'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.paymentLine2"
              no="paymentLine2"
              :disabled="readonly || !elementDict.payment.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine2','paymentLine3',0)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Addr') + '2'"
            class="auto-width"
          >
            <cargo-input
              v-model="form.paymentLine3"
              no="paymentLine3"
              :disabled="readonly || !elementDict.payment.writable"
              :filter-chars="false"
              :use-read-only="true"
              @dblclick.native="showPaymentDialog"
              @change="()=>wrapAddr(form,'paymentLine1','paymentLine2',0)"
            />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Country')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.paymentCountry"
                no="paymentCountry"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_CityP')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.paymentCity"
                  no="paymentCity"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Province1')"
            class="auto-width"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.paymentProvince"
                no="paymentProvince"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_PostalCode')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.paymentPostalCode"
                  no="paymentPostalCode"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Tel')"
          >
            <div style="display:flex;">
              <el-input
                v-model="form.paymentPhone"
                no="paymentPhone"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="$t('CargoMsg.Cargo_email')"
                label-width="70px"
                class="auto-width"
              >
                <el-input
                  v-model="form.paymentEmail"
                  no="paymentEmail"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_Contact')"
            class="auto-width"
          >
            <div style="display:flex;padding-bottom: 5px">
              <el-input
                v-model="form.paymentContact"
                no="paymentContact"
                style="width: 100px"
                :disabled="readonly || !elementDict.payment.writable"
              />
              <el-form-item
                :label="'Fax'"
                label-width="70px"
              >
                <el-input
                  v-model="form.paymentFax"
                  no="paymentFax"
                  style="width: 100px"
                  :disabled="readonly || !elementDict.payment.writable"
                />
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </template>
      <el-form-item v-if="elementDict.syncContainerInfoTotal.viewable" slot="syncContainerInfoTotal" style="display: flex; justify-content: flex-end;">
        <el-button type="primary" :disabled="synContainerInfoDisable || readonly || !elementDict.syncContainerInfoTotal.writable" @click="syncContainerInfoDialogHandle">{{ $t('SeaExport.SyncContainerInfoTotal') }}</el-button>
      </el-form-item>
      <el-form-item
        v-if="elementDict.quantity.viewable"
        slot="quantity"
        :class="variableCss.quantity"
      >
        <line-label slot="label" :class="elementDict.quantity.isRequire ? 'blue' : ''" :label="elementDict.quantity.label" />
        <auto-number-input
          v-model="form.quantity"
          no="31"
          :precision="0"
          :min="0"
          :disabled="!isJydEditJobFields || readonly || !elementDict.quantity.writable"
          @change="pm.quantityChange()"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.packing.viewable"
        slot="packing"
        :class="variableCss.packing"
      >
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="32"
          :default-value="form.packing"
          :disabled="readonly || !elementDict.packing.writable"
          @change="p => {pm.packingChange(p)}"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.packingName.viewable"
        slot="packingName"
      >
        <line-label slot="label" :class="elementDict.packingName.isRequire ? 'blue' : ''" :label="elementDict.packingName.label" />
        <el-input v-model="form.packingName" no="33" :disabled="readonly || !elementDict.packingName.writable" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.insideQuantity.viewable"
        slot="insideQuantity"
        :class="variableCss.insideQuantity"
      >
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="form.insideQuantity"
          :disabled="readonly || !elementDict.insideQuantity.writable"
          no="34"
          :precision="0"
          :min="0"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.insidePacking.viewable"
        slot="insidePacking"
        :class="variableCss.insidePacking"
      >
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          no="35"
          :disabled="readonly || !elementDict.insidePacking.writable"
          :default-value="form.insidePacking"
          @change="p => {form.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.weight.viewable"
        slot="weight"
        :class="variableCss.weight"
      >
        <line-label slot="label" :class="elementDict.weight.isRequire ? 'blue' : ''" :label="elementDict.weight.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
          <el-input-number
            v-model="form.weight"
            no="36"
            :precision="3"
            :min="0"
            :controls="false"
            :disabled="!isJydEditJobFields || readonly || !elementDict.weight.writable"
            style="flex:1"
            @change="p=>{CargoDocUtil.changeBillOfLadingSynJob(job, form, true);pm.calculateChargeWeight();}"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item
        v-if="elementDict.cubage.viewable"
        slot="cubage"
        :class="variableCss.cubage"
      >
        <line-label slot="label" :class="elementDict.cubage.isRequire ? 'blue' : ''" :label="elementDict.cubage.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
          <el-input-number
            v-model="form.cubage"
            no="37"
            :precision="3"
            :min="0"
            :controls="false"
            :disabled="!isJydEditJobFields || readonly || !elementDict.cubage.writable"
            style="flex:1"
            @change="p=>{CargoDocUtil.changeBillOfLadingSynJob(job, form, true);pm.calculateChargeWeight();}"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item
        v-if="elementDict.chargeWeight.viewable"
        slot="chargeWeight"
      >
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
          <el-input-number
            v-model="form.chargeWeight"
            no="38"
            :precision="3"
            :min="0"
            :controls="false"
            style="flex: 1"
            :disabled="readonly || !elementDict.chargeWeight.writable"
            @change="CargoDocUtil.changeBillOfLadingSynJob(job, form)"
          />
          <span>M/T</span>
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName">
        <el-form-item
          v-if="isZh"
          class="auto-width"
          :class="variableCss.cargoEnglishName"
        >
          <div style="display: flex;justify-content: flex-end">
            <div>
              <el-button
                no="39"
                type="primary"
                :disabled="readonly || !elementDict.cargoEnglishName.writable"
                @click="pm.getHBLInfo('EName')"
              >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromHBL') }}
              </el-button>
              <el-button
                v-show="masterFlag"
                no="40"
                type="primary"
                style="margin-top: 5px"
                :disabled="readonly || !elementDict.cargoEnglishName.writable"
                @click="pm.getSlavesHBLEnglishName()"
              >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt') }}
              </el-button>
            </div>
          </div>
        </el-form-item>
        <template v-if="!isZh">
          <el-form-item
            class="auto-width"
            :class="variableCss.cargoEnglishName"
          >
            <el-button
              no="41"
              type="primary"
              :disabled="readonly || !elementDict.cargoEnglishName.writable"
              @click="pm.getHBLInfo('EName')"
            >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromHBL') }}
            </el-button>
          </el-form-item>
          <el-form-item
            v-show="masterFlag"
            class="auto-width"
            :class="variableCss.cargoEnglishName"
          >
            <el-button
              no="42"
              type="primary"
              :disabled="readonly || !elementDict.cargoEnglishName.writable"
              @click="pm.getSlavesHBLEnglishName()"
            >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt') }}
            </el-button>
          </el-form-item>
        </template>
      </template>
      <el-form-item
        v-show="elementDict.cargoEnglishName.viewable"
        slot="cargoEnglishName"
        class="auto-width"
        :class="variableCss.cargoEnglishName"
      >
        <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
        <special-character-tip :texts="specialCharCheck.cargoEnglishName">
          <cargo-rich-textarea
            ref="cargoTextarea1"
            v-model="form.cargoEnglishName"
            no="43"
            :show-count="true"
            :text-chars="englishNameMaxChars"
            :warning-count="englishNameWarningCount"
            wrap-symbol="r"
            :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
            :auto-uppercase="isUppercaseByConfig"
            auto-half-word
            style="height: 110px"
            @change="pm.cargoEnglishNameBlurHandler()"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,isUppercaseByConfig , {
              warningCount: englishNameWarningCount,
              maxChar: englishNameMaxChars,autoUppercase:isUppercaseByConfig,autoHalfWord:true
            })"
          />
        </special-character-tip>
      </el-form-item>
      <template v-if="elementDict.mark.viewable" slot="mark">
        <el-form-item
          v-if="isZh"
          class="auto-width"
          :class="variableCss.mark"
        >
          <div style="display: flex;justify-content: flex-end">
            <div>
              <el-button
                no="44"
                type="primary"
                :disabled="readonly || !elementDict.mark.writable"
                @click="pm.getHBLInfo('mark')"
              >{{ $t('SeaExport.CopyMarksFromHbl') }}
              </el-button>
              <el-button
                v-show="masterFlag"
                no="45"
                type="primary"
                style="margin-top: 5px"
                :disabled="readonly || !elementDict.mark.writable"
                @click="pm.getSlavesHBLMark()"
              >{{ $t('SeaExport.CopyMarksFromReceipt') }}
              </el-button>
            </div>
          </div>

        </el-form-item>
        <template v-if="!isZh">
          <el-form-item
            class="auto-width"
            :class="variableCss.mark"
          >
            <el-button
              no="46"
              type="primary"
              :disabled="readonly || !elementDict.mark.writable"
              @click="pm.getHBLInfo('mark')"
            >{{ $t('SeaExport.CopyMarksFromHbl') }}
            </el-button>
          </el-form-item>
          <el-form-item
            class="auto-width"
            :class="variableCss.mark"
          >
            <el-button
              v-show="masterFlag"
              no="47"
              type="primary"
              :disabled="readonly || !elementDict.mark.writable"
              @click="pm.getSlavesHBLMark()"
            >{{ $t('SeaExport.CopyMarksFromReceipt') }}
            </el-button>
          </el-form-item>
        </template>
      </template>
      <el-form-item
        v-show="elementDict.mark.viewable"
        slot="mark"
        class="auto-width"
        :class="variableCss.mark"
      >
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <special-character-tip :texts="specialCharCheck.mark">
          <cargo-rich-textarea
            ref="cargoTextarea2"
            v-model="form.mark"
            no="48"
            :show-count="true"
            :text-chars="markMaxChars"
            :warning-count="markWarningCount"
            wrap-symbol="r"
            :disabled="!isEdit || !elementDict.mark.writable"
            :auto-uppercase="isUppercaseByConfig"
            auto-half-word
            style="height: 110px"
            @change="pm.markBlurHandler()"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,isUppercaseByConfig , {
              warningCount: markWarningCount,
              maxChar: markMaxChars,autoUppercase:isUppercaseByConfig,autoHalfWord:true
            })"
          />
        </special-character-tip>
      </el-form-item>
      <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
        <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
        <el-input
          v-if="syncMblHsCodeEdit"
          v-model="form.hsCode"
          no="49"
          type="textarea"
          :rows="5"
          style="width: 100%"
          :disabled="readonly || !elementDict.hsCode.writable"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode = val})"
        />
        <el-input
          v-else
          v-model="job.hsCode"
          no="49"
          type="textarea"
          :rows="5"
          style="width: 100%"
          :disabled="readonly || !elementDict.hsCode.writable"
          @input="val=>{hsCodeChangeHandle(val)}"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{hsCodeChangeHandle(val)})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.quantitySum.viewable" slot="quantitySum" class="auto-width">
        <line-label slot="label" :class="elementDict.quantitySum.isRequire ? 'blue' : ''" :label="elementDict.quantitySum.label" />
        <el-input
          v-model="form.quantitySum"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cusCode.viewable" slot="cusCode">
        <line-label slot="label" :class="elementDict.cusCode.isRequire ? 'blue' : ''" :label="elementDict.cusCode.label" />
        <el-input v-model="form.cusCode" no="cusCode" :disabled="readonly || !elementDict.cusCode.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.ncmNo.viewable" slot="ncmNo">
        <line-label slot="label" :class="elementDict.ncmNo.isRequire ? 'blue' : ''" :label="elementDict.ncmNo.label" />
        <el-input v-model="form.ncmNo" no="ncmNo" :disabled="readonly || !elementDict.ncmNo.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.mbl.viewable" slot="mbl">
        <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
        <el-input v-model="job.mbl" no="50" :class="job.mbl==='CANCELLED'?'mbl-red':''" :disabled="readonly || !elementDict.mbl.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.soNo.viewable" slot="soNo" :class="variableCss.soNoTitle">
        <line-label slot="label" :class="elementDict.soNo.isRequire ? 'blue' : ''" :label="elementDict.soNo.label" />
        <so-no-input v-model="job.soNo" :disabled="true" :class="variableCss.soNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.serialNo.viewable" slot="serialNo" class="custom">
        <line-label slot="label" :class="elementDict.serialNo.isRequire ? 'blue' : ''" :label="elementDict.serialNo.label" />
        <el-input v-model="form.serialNo" no="51" :disabled="readonly || !elementDict.serialNo.writable" />
      </el-form-item>
      <template v-if="elementDict.vesselVoyage.viewable" slot="vesselVoyage">
        <el-form-item v-if="isHZ" :label="$t('SeaExport.VesselAndVoyage')">
          <line-label slot="label" :class="elementDict.vesselVoyage.isRequire ? 'blue' : ''" :label="elementDict.vesselVoyage.label" />
          <el-input v-model="form.vesselVoyage" no="82" :disabled="readonly || !elementDict.vesselVoyage.writable" />
        </el-form-item>
        <el-form-item v-else :label="$t('SeaExport.VesselAndVoyage')" :class="variableCss.txtFirstVesselVoyageTitle">
          <line-label slot="label" :class="elementDict.vesselVoyage.isRequire ? 'blue' : ''" :label="elementDict.vesselVoyage.label" />
          <el-input
            :disabled="true"
            :value="txtFirstVesselVoyage"
            :class="variableCss.txtFirstVesselVoyage"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.sailingDate.viewable" slot="sailingDate">
        <line-label slot="label" :class="elementDict.sailingDate.isRequire ? 'blue' : ''" :label="elementDict.sailingDate.label" />
        <el-input
          :value="sailingDate"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.dispatchingPlaceCode.viewable"
        slot="dispatchingPlaceCode"
        :class="variableCss.dispatchingPlace"
      >
        <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dispatchingPlaceCode||''"
          tag-name="englishName"
          @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
        />
        <el-input v-model="form.dispatchingPlace" no="52" :disabled="readonly || !elementDict.dispatchingPlaceCode.writable" :filter-chars="false" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.loadingPortCode.viewable"
        slot="loadingPortCode"
        :class="variableCss.loadingPort"
      >
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.loadingPortCode||''"
          tag-name="englishName"
          no="loadingPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
        />
        <el-input v-model="form.loadingPort" no="53" :disabled="readonly || !elementDict.loadingPortCode.writable" :filter-chars="false" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.dischargingPortCode.viewable"
        slot="dischargingPortCode"
        :class="variableCss.dischargingPort"
      >
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode||''"
          tag-name="englishName"
          no="dischargingPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
        />
        <el-input v-model="form.dischargingPort" no="54" :disabled="readonly" :filter-chars="false" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.destinationPortCode.viewable"
        slot="destinationPortCode"
        :class="variableCss.destinationPort"
      >
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode||''"
          tag-name="englishName"
          no="destinationPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
        />
        <el-input v-model="form.destinationPort" no="55" :disabled="readonly || !elementDict.destinationPortCode.writable" :filter-chars="false" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input v-model="form.destinationPlace" no="56" :disabled="readonly || !elementDict.destinationPlace.writable" :filter-chars="false" />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <el-input
          :disabled="true"
          :value="ColumnUtils.paymentTermLabelFunc(job.paymentTermMBL)"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentPlaceBL.viewable" slot="paymentPlaceBL">
        <line-label slot="label" :class="elementDict.paymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.paymentPlaceBL.label" />
        <el-input
          :disabled="true"
          :value="form.paymentPlaceBL"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.viewable" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <el-input
          :disabled="true"
          :value="job.freightTerm"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.blNumber.viewable"
        slot="blNumber"
        :class="variableCss.BLNumber"
      >
        <line-label slot="label" :class="elementDict.blNumber.isRequire ? 'blue' : ''" :label="elementDict.blNumber.label" />
        <el-input v-model="form.blNumber" no="57" :disabled="readonly || !elementDict.blNumber.writable" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.blCopyNumber.viewable"
        slot="blCopyNumber"
      >
        <line-label slot="label" :class="elementDict.blCopyNumber.isRequire ? 'blue' : ''" :label="elementDict.blCopyNumber.label" />
        <el-input v-model="form.blCopyNumber" no="58" :disabled="readonly || !elementDict.blCopyNumber.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.signPlaceBL.viewable" slot="signPlaceBL">
        <line-label slot="label" :class="elementDict.signPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.signPlaceBL.label" />
        <el-input v-model="form.signPlaceBL" no="59" :disabled="readonly || !elementDict.signPlaceBL.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.signDateBL.viewable" slot="signDateBL">
        <line-label slot="label" :class="elementDict.signDateBL.isRequire ? 'blue' : ''" :label="elementDict.signDateBL.label" />
        <el-date-picker
          v-model="form.signDateBL"
          :disabled="readonly || !elementDict.signDateBL.writable"
          no="60"
          style="width: 100%"
          type="date"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.remarks.viewable"
        slot="remarks"
        :class="variableCss.remarks"
      >
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <cargo-input
          v-model="form.remarks"
          no="61"
          :class="variableCss.remarks"
          type="textarea"
          :rows="5"
          :filter-chars="false"
          :disabled="readonly || !elementDict.remarks.writable"
          :use-read-only="true"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val}, false, null, false, {
            warningCount: -1,
            maxChar: 0,
            autoUppercase: false,
            autoHalfWord: false
          })"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.releaseType.viewable" slot="releaseType">
        <line-label slot="label" :class="elementDict.releaseType.isRequire ? 'blue' : ''" :label="elementDict.releaseType.label" />
        <el-select
          v-model="form.releaseType"
          no="62"
          :disabled="readonly || !elementDict.releaseType.writable"
          @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in blModeList"
            :key="index"
            :label="item.name"
            :value="item.serialNumber"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.typeMBL.viewable" slot="typeMBL">
        <line-label slot="label" :class="elementDict.typeMBL.isRequire ? 'blue' : ''" :label="elementDict.typeMBL.label" />
        <el-select
          no="63"
          :value="job.typeMBL||1"
          :disabled="cmbtypeMBLDisabled || readonly || !elementDict.typeMBL.writable"
          @input="val=>{pm.cmbtypeMBLChangeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in BILL_TYPES"
            :key="index"
            :label="isZh ? item.chineseName : item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="elementDict.jointMasterMBLJobNo.viewable && job.jointMasterMBLUuid"
        slot="jointMasterMBLJobNo"
      >
        <line-label slot="label" :class="elementDict.jointMasterMBLJobNo.isRequire ? 'blue' : ''" :label="elementDict.jointMasterMBLJobNo.label" />
        <el-input :value="job.jointMasterMBL?job.jointMasterMBL.jobNo:''" :disabled="true" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.lblCfrState.viewable"
        slot="lblCfrState"
        class="red"
      >
        <line-label slot="label" :class="elementDict.lblCfrState.isRequire ? 'blue' : ''" :label="elementDict.lblCfrState.label" />
        <el-input
          :disabled="true"
          :value="lblCfrState"
          style="margin-bottom: 5px"
        />
        <cargo-button-container
          v-permission="['button_SingleRelease_singleRelease']"
          no="64"
          :disabled="btnReleasingDisabled || !cooperateEdit || !elementDict.lblCfrState.writable"
          style="float:right;margin-left:5px"
          @click="pm.btnReleasingClickHandler()"
        >
          <el-button type="primary">{{
            form.cfmState === 10 ? $t('SeaExport.CancelReleasing') : $t('SeaExport.Releasing')
          }}
          </el-button>
        </cargo-button-container>
        <!--取回/撤销取回按钮-->
        <cargo-button-container
          v-permission="['button_SingleRelease_getBack']"
          no="65"
          :disabled="btnGetBackDisabled || !cooperateEdit || !elementDict.lblCfrState.writable"
          style="float:right"
          @click="pm.btnGetBackClickHandler()"
        >
          <el-button type="primary">{{
            form.bliStatus === 7 ? $t('SeaExport.CancelGetBack') : $t('SeaExport.Back')
          }}
          </el-button>
        </cargo-button-container>
      </el-form-item>
      <!-- 提单签发状态 -->
      <el-form-item v-if="elementDict.billLadingIssued.viewable" slot="billLadingIssued" class="red">
        <line-label slot="label" :class="elementDict.billLadingIssued.isRequire ? 'blue' : ''" :label="elementDict.billLadingIssued.label" />
        <el-input v-model="billLadingIssued" :disabled="true" />
      </el-form-item>
      <el-form-item
        v-if="elementDict.lblReleaseState.viewable"
        slot="lblReleaseState"
        class="red"
      >
        <line-label slot="label" :class="elementDict.lblReleaseState.isRequire ? 'blue' : ''" :label="elementDict.lblReleaseState.label" />
        <el-input
          :disabled="true"
          :value="lblReleaseState"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.requestReleaseState.viewable" slot="requestReleaseState" class="red">
        <line-label slot="label" :class="elementDict.requestReleaseState.isRequire ? 'blue' : ''" :label="elementDict.requestReleaseState.label" />
        <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
        <span style="float:left;margin-left:-85px">{{ job.jointMasterMBLUuid ? $t('SeaExport.TicketHasMerged') : (job.typeMBL === BillType.SPLIT_BILL_TYPE.code) ? $t('SeaExport.TicketHasSplit') : '' }}</span>
        <cargo-button-container
          no="requestReleaseState"
          :disabled="btnBLConfirmDisabled || !cooperateEdit || !elementDict.requestReleaseState.writable"
          style="float:right;margin-left:5px"
          @click="pm.btnRequestReleasingClickHandler()"
        >
          <el-button v-permission="['button_M/HBL_SingleReleaseMBL']" :disabled="job.jointMasterMBLUuid || job.typeMBL === BillType.SPLIT_BILL_TYPE.code" type="primary">
            {{ form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease') }}
          </el-button>
        </cargo-button-container>
      </el-form-item>
      <el-form-item v-if="elementDict.releaseEligibleStatus && elementDict.releaseEligibleStatus.viewable" slot="releaseEligibleStatus" class="red">
        <line-label slot="label" :class="elementDict.releaseEligibleStatus.isRequire ? 'blue' : ''" :label="elementDict.releaseEligibleStatus.label" />
        <el-input :value="releaseEligibleLabel" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.reviewDate.viewable" slot="reviewDate">
        <line-label slot="label" :class="elementDict.reviewDate.isRequire ? 'blue' : ''" :label="elementDict.reviewDate.label" />
        <el-date-picker
          v-model="form.reviewDate"
          :disabled="true"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.withholdDate.viewable" slot="withholdDate">
        <line-label slot="label" :class="elementDict.withholdDate.isRequire ? 'blue' : ''" :label="elementDict.withholdDate.label" />
        <el-date-picker
          v-model="form.withholdDate"
          :disabled="true"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.surrenderedNo.viewable" slot="surrenderedNo">
        <line-label slot="label" :class="elementDict.surrenderedNo.isRequire ? 'blue' : ''" :label="elementDict.surrenderedNo.label" />
        <el-input
          :disabled="true"
          :value="form.surrenderedNo"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.releaseDate.viewable" slot="releaseDate">
        <line-label slot="label" :class="elementDict.releaseDate.isRequire ? 'blue' : ''" :label="elementDict.releaseDate.label" />
        <el-date-picker
          v-model="form.releaseDate"
          :disabled="true"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.printParam4.viewable" slot="printParam4">
        <line-label slot="label" :class="elementDict.printParam4.isRequire ? 'blue' : ''" :label="elementDict.printParam4.label" />
        <el-select v-model="form.printParam4" no="66" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" :disabled="readonly || !elementDict.printParam4.writable">
          <el-option
            v-for="(item,index) in pm.printParam4Type"
            :key="index"
            :label="item.label"
            :value="item.data"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.txtCarrierScAc.viewable" slot="txtCarrierScAc">
        <line-label slot="label" :class="elementDict.txtCarrierScAc.isRequire ? 'blue' : ''" :label="elementDict.txtCarrierScAc.label" />
        <el-input
          :disabled="true"
          :value="job.carrierScac || txtCarrierScAc"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtBookingAgentScAc.viewable" slot="txtBookingAgentScAc">
        <line-label slot="label" :class="elementDict.txtBookingAgentScAc.isRequire ? 'blue' : ''" :label="elementDict.txtBookingAgentScAc.label" />
        <el-input
          :disabled="true"
          :value="txtBookingAgentScAc"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoManifestName.viewable" slot="cargoManifestName">
        <line-label slot="label" :class="elementDict.cargoManifestName.isRequire ? 'blue' : ''" :label="elementDict.cargoManifestName.label" />
        <cargo-rich-textarea
          v-model="form.cargoManifestName"
          no="67"
          :disabled="readonly || !elementDict.cargoManifestName.writable"
          style="height: 110px;"
          :text-chars="0"
          :warning-count="-1"
          wrap-symbol="r"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.ManifestDescriptionOfGoods'),form.cargoManifestName,val=>{form.cargoManifestName=val},false,null,true, {
            warningCount: -1,
            maxChar: 0,
            autoUppercase: false,
            autoHalfWord: false
          })"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.withholdReason.viewable" slot="withholdReason">
        <line-label slot="label" :class="elementDict.withholdReason.isRequire ? 'blue' : ''" :label="elementDict.withholdReason.label" />
        <el-input
          :disabled="true"
          :value="form.withholdReason"
          type="textarea"
          :rows="5"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.modificationCount.viewable" slot="modificationCount">
        <line-label slot="label" :class="elementDict.modificationCount.isRequire ? 'blue' : ''" :label="elementDict.modificationCount.label" />
        <auto-number-input v-model="form.modificationCount" :precision="0" :min="0" no="modificationCount" :disabled="readonly || !elementDict.modificationCount.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.portRequirement.viewable" slot="portRequirement">
        <line-label slot="label" :class="elementDict.portRequirement.isRequire ? 'blue' : ''" :label="elementDict.portRequirement.label" />
        <el-input v-model="form.portRequirement" no="portRequirement" type="textarea" :rows="5" :disabled="readonly || !elementDict.portRequirement.writable" />
        <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
          <i class="el-icon-paperclip" style="font-size: 16px;" />
          <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
        </div>
      </el-form-item>
    </tab-MBLUICustom-layout>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      :width="advanceTextDialog.showContact ? '900px' : '600px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      class="app-main-inner edi-bill-search-selector"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <div class="app-main-inner-row">
        <el-form
          label-width="50px"
          label-position="left"
        >
          <el-row
            v-show="advanceTextDialog.showContact"
            :gutter="10"
            style="padding-top: 20px;"
          >
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.ContactPerson')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.contact"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.Tel')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.mobile"
                  :autocomplete="$t('SeaExport.Tel')"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.Fax')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.fax"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-show="advanceTextDialog.showContact"
            :gutter="10"
          >
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.Email2')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.email"
                  :autocomplete="$t('SeaExport.Email2')"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.ZIP')"
              >
                <el-input
                  v-model="advanceTextDialog.extendData.zipCode"
                  :disabled="readonly"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('SeaExport.City')"
              >
                <!--<cargo-location-select
                  :disabled="readonly"
                  :default-value="advanceTextDialog.extendData.city"
                  style="width:180px;"
                  @change="p=>{advanceTextDialog.extendData.city=p.value}"
                />-->
                <cargo-advance-select
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="advanceTextDialog.extendData.city"
                  options-width="110px"
                  @parentCallBack="p=>{advanceTextDialog.extendData.city=p.value}"
                />&nbsp;
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          v-show="isEdit"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :params="billAddressDialog.params"
      :job="job"
      @callback="codeSearchCallback"
    />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!-- 邀请对单弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :context="context"
      :job="job"
      source="tabMBL"
      :push-link="SystemConstants.MBL_INVITATION_STATEMENT"
      :is-copy-link="true"
      :job-eamil-data="jobEamilData"
      :send-email-data="emailInput"
      :send-call-back="onEmailExecute"
    />
    <!-- 对单历史弹窗 -->
    <match-history-dialog
      :visible.sync="matchHistoryDialog.visible"
      :cargo-doc-uuid="form.uuid"
    />
    <!-- 回执历史弹窗 -->
    <receipt-history-dialog
      :visible.sync="receiptHistoryDialog.visible"
      :job-uuid="job.uuid||''"
    />
    <!-- 提单日志弹窗 -->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="form.uuid"
    />
    <!-- edi弹窗选择器 -->
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <!-- 报文预览弹窗 -->
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="{}"
    />
    <edi-doc-window
      v-if="ediDocWindow.visible"
      ref="ediDocWindow"
      :visible="ediDocWindow.visible"
      :global-var="globalVar"
      :edi-status-name="ediStatusName"
      :call-back-func="ediDocWindow.callBackFunc"
      :context="context"
      @close="ediDocWindow.visible =false"
    />
    <!-- 舱单-多段号码规则配置-弹窗 -->
    <multi-seg-num-rules-dialog
      :visible.sync="multiSegNumRulesDialog.visible"
      @callback="multiSegNumRulesCallback"
    />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="selectedApiCallback"
    />
    <!-- 错误日志显示弹窗 -->
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />
    <!-- 提单补充信息 -->
    <cargo-doc-extend
      :visible.sync="cargoDocExtendDialog.visible"
      :title="cargoDocExtendDialog.title"
      :job-uuid="job.uuid"
      :sea-cargo-doc="form"
      :carrier-id="job.carrierId"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
    />
    <!--取装箱信息件毛体-->
    <sync-container-info-dialog
      ref="syncContainerInfoDialog"
      :visible.sync="syncContainerInfoDialog.visible"
      :change-post-func="syncContainerInfoChangeHandle"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabMBLUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBLUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabMBL from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'TabMBLUICustom',
  components: { tabMBLUICustomLayout },
  extends: tabMBL,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      ColumnUtils,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_MBL, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_MBL, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
      this.ensureReleaseEligibleStatus()
    },
    ensureReleaseEligibleStatus() {
      if (this.elementDict && this.elementDict.releaseEligibleStatus) return
      if (!this.elementDict) this.elementDict = {}
      const label = this.$t('SeaExport.ReleaseEligibleStatus')
      this.elementDict.releaseEligibleStatus = {
        visible: true,
        masterVisible: true,
        slaveVisible: true,
        isRequire: false,
        customLabel: null,
        label,
        fieldNames: [],
        multipleRole: null,
        jobPositionFields: null,
        ownPrivilegePositionFields: null,
        positionPrivilegeViewable: null,
        positionPrivilegeWritable: null,
        viewable: true,
        writable: false,
        userCustomContent: '',
        customContent: ''
      }
      if (!Array.isArray(this.elementBlocks)) return
      const targetBlock = this.elementBlocks.find(block => Array.isArray(block.elementNames) && block.elementNames.includes('requestReleaseState')) || this.elementBlocks[0]
      if (!targetBlock || !Array.isArray(targetBlock.elementNames)) return
      if (!targetBlock.elementNames.includes('releaseEligibleStatus')) {
        const index = targetBlock.elementNames.indexOf('requestReleaseState')
        if (index >= 0) {
          targetBlock.elementNames.splice(index + 1, 0, 'releaseEligibleStatus')
        } else {
          targetBlock.elementNames.push('releaseEligibleStatus')
        }
      }
    },
    validateForm() {
      const form = this.form
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!(element.visible && element.writable && element.isRequire)) {
          continue
        }
        if (name === 'shipper') {
          let shipperLine = ''
          for (let i = 1; i <= 7; ++i) {
            shipperLine += form['shipperLine' + i]
          }
          if (StrUtils.isEmpty(shipperLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'consignee') {
          let consigneeLine = ''
          for (let i = 1; i <= 7; ++i) {
            consigneeLine += form['consigneeLine' + i]
          }
          if (StrUtils.isEmpty(consigneeLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'notify') {
          let notifyLine = ''
          for (let i = 1; i <= 7; ++i) {
            notifyLine += form['notifyLine' + i]
          }
          if (StrUtils.isEmpty(notifyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'payment') {
          if (this.job.paymentTermMBL === '3P') {
            let paymentLine = ''
            for (let i = 1; i <= 7; ++i) {
              paymentLine += form['paymentLine' + i]
            }
            if (StrUtils.isEmpty(paymentLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
            }
          }
          continue
        }
        if (name === 'mbl') {
          if (StrUtils.isEmpty(this.job.mbl)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'dispatchingPlaceCode') {
          if (StrUtils.isEmpty(form.dispatchingPlaceCode) || StrUtils.isEmpty(form.dispatchingPlace)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'loadingPortCode') {
          if (StrUtils.isEmpty(form.loadingPortCode) || StrUtils.isEmpty(form.loadingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'dischargingPortCode') {
          if (StrUtils.isEmpty(form.dischargingPortCode) || StrUtils.isEmpty(form.dischargingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'destinationPortCode') {
          if (StrUtils.isEmpty(form.destinationPortCode) || StrUtils.isEmpty(form.destinationPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (name === 'hsCode') {
          const hsCode = this.syncMblHsCodeEdit ? form.hsCode : this.job.hsCode
          if (StrUtils.isEmpty(hsCode)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabMBL')
          }
          continue
        }
        if (element.fieldNames && element.fieldNames.length > 0) {
          for (const key of element.fieldNames) {
            const field = this.fieldDict[key]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabMBL')
            }
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return this.superFunction()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-submenu__title{
  border-bottom: none !important;
}
.mbl-red::v-deep{
  .el-input__inner {
    color: red !important;
  }
}
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
